import { render, staticRenderFns } from "./statusConformationDialog.vue?vue&type=template&id=b32b4cd0"
import script from "./statusConformationDialog.vue?vue&type=script&lang=js"
export * from "./statusConformationDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports